import '../calendar/calendar.component';
import { DatePicker } from './date-picker.component';

export * from './date-picker.component';
export default DatePicker;

if (!customElements.get('der-tm-appointment-booking-date-picker')) {
    customElements.define('der-tm-appointment-booking-date-picker', DatePicker);
}
